export const GET_POSITIONS_START = 'GET_POSITIONS_START';
export const GET_POSITIONS_SUCCESS = 'GET_POSITIONS_SUCCESS';
export const GET_POSITIONS_FAIL = 'GET_POSITIONS_FAIL';

export const GET_POSITION_START = 'GET_POSITION_START';
export const GET_POSITION_SUCCESS = 'GET_POSITION_SUCCESS';
export const GET_POSITION_FAIL = 'GET_POSITION_FAIL';

export const GET_POSITION_STATISTICS_START = 'GET_POSITION_STATISTICS_START';
export const GET_POSITION_STATISTICS_SUCCESS = 'GET_POSITION_STATISTICS_SUCCESS';
export const GET_POSITION_STATISTICS_FAIL = 'GET_POSITION_STATISTICS_FAIL';
